// Overgezet uit naslag/server/imports/api/types/inGameEffect.ts.
export var InGameEffect;
(function (InGameEffect) {
    InGameEffect["obs"] = "obs";
    InGameEffect["assetData"] = "assetData";
    InGameEffect["diceRed"] = "diceRed";
    InGameEffect["diceYellow"] = "diceYellow";
    InGameEffect["newMechanic"] = "newMechanic";
    InGameEffect["upgradeMechanic"] = "upgradeMechanic";
    InGameEffect["upgradeMechanic4to5"] = "upgradeMechanic4to5";
    InGameEffect["upgradeAllMechanics"] = "upgradeAllMechanics";
    InGameEffect["cleanStorage"] = "cleanStorage";
    InGameEffect["sellSparepart"] = "sellSparepart";
    InGameEffect["chooseSparepart"] = "chooseSparepart";
    InGameEffect["buySparepart"] = "buySparepart";
    InGameEffect["getBudget"] = "getBudget";
    InGameEffect["revision"] = "revision";
    InGameEffect["cookies"] = "cookies";
    InGameEffect["cookiesInfinite"] = "cookiesInfinite";
    InGameEffect["resolveIncident"] = "resolveIncident";
    InGameEffect["resolveMalfunction"] = "resolveMalfunction";
    InGameEffect["plus2AvailabilityOnce"] = "plus2AvailabilityOnce";
    InGameEffect["plus5AvailabilityOnce"] = "plus5AvailabilityOnce";
    InGameEffect["plus5AvailabilityAlways"] = "plus5AvailabilityAlways";
    InGameEffect["stakeholderCalling"] = "stakeholderCalling";
    InGameEffect["mikeRetires"] = "mikeRetires";
    InGameEffect["extraSparepart"] = "extraSparepart";
    InGameEffect["budgetIfNoIncidents"] = "budgetIfNoIncidents";
    InGameEffect["mechanicAccident"] = "mechanicAccident";
    InGameEffect["mechanicInjured"] = "mechanicInjured";
    InGameEffect["mechanicLeaves"] = "mechanicLeaves";
    // Niet in het origineel: de topmonteur van Amanda van HR komt meteen in dienst.
    InGameEffect["newTopMechanic"] = "newTopMechanic";
})(InGameEffect || (InGameEffect = {}));
